import * as React from 'react';

export default () => (
    <div className="row" style={styles.root}>
        <div className="col">
            <div>
                <img style={styles.image} src="/img/404-image@2x.png" alt="404 Not Found" />
            </div>
            <div>
                <h1 style={styles.title}>404: The page you are looking for doesn’t exist</h1>
            </div>
        </div>
    </div>
);

const styles = {
  root: {
    minHeight: '100vh',
    textAlign: 'center',
  },
  image: {
    width: 80,
    marginBottom: '1rem',
    marginTop: '1rem',
  },
  title: {
    fontSize: '1em',
  },
};



// WEBPACK FOOTER //
// ./src/screens/NotFound.tsx